import React from 'react';

/**
 * ErrorBoundary global — évite l'écran blanc en cas d'exception React.
 * Affiche un message de recovery + bouton de rechargement.
 */
export default class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Log accessible côté navigateur
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    const msg = this.state.error?.message || String(this.state.error || 'Erreur inconnue');
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '24px', fontFamily: 'system-ui, sans-serif', background: '#F8FAFC',
      }} data-testid="global-error-boundary">
        <div style={{
          maxWidth: 520, background: 'white', borderRadius: 16, padding: 32,
          boxShadow: '0 10px 30px rgba(15,23,42,0.08)', border: '1px solid #E2E8F0',
        }}>
          <div style={{
            width: 48, height: 48, borderRadius: 12, background: '#FEE2E2',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            marginBottom: 16, fontSize: 24,
          }}>⚠️</div>
          <h1 style={{ fontSize: 20, fontWeight: 700, color: '#0F172A', marginBottom: 8 }}>
            Une erreur inattendue s'est produite
          </h1>
          <p style={{ fontSize: 13, color: '#64748B', marginBottom: 16, lineHeight: 1.5 }}>
            L'application a rencontré un problème et n'a pas pu afficher cette page. Rechargez pour continuer.
          </p>
          <div style={{
            background: '#F1F5F9', borderRadius: 8, padding: 12, marginBottom: 16,
            fontSize: 11, color: '#475569', fontFamily: 'monospace', wordBreak: 'break-word',
            maxHeight: 120, overflow: 'auto',
          }}>{msg}</div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: '#1C49A6', color: 'white', border: 'none', borderRadius: 8,
                padding: '10px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer',
              }}
              data-testid="error-boundary-reload"
            >Recharger l'application</button>
            <button
              onClick={() => window.location.assign('/')}
              style={{
                background: 'white', color: '#1C49A6', border: '1px solid #1C49A6',
                borderRadius: 8, padding: '10px 16px', fontSize: 13, fontWeight: 600,
                cursor: 'pointer',
              }}
            >Retour à l'accueil</button>
          </div>
        </div>
      </div>
    );
  }
}
